import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

const StatCard = ({
  title,
  value,
  subValue,
  trend,
  icon: Icon,
  iconColorClass,
  iconBgClass,
}) => (
  <div className="bg-white py-3 px-6 rounded-2xl border border-slate-100 shadow-md">
    <div className="flex justify-between items-start mb-4">
      <div className={`p-2 ${iconBgClass} rounded-lg`}>
        <Icon size={20} className={iconColorClass} />
      </div>
      {trend && (
        <span
          className={`flex items-center text-xs font-bold ${
            parseFloat(trend) >= 0 ? "text-emerald-600" : "text-rose-600"
          }`}
        >
          {parseFloat(trend) >= 0 ? (
            <ArrowUpRight size={14} />
          ) : (
            <ArrowDownRight size={14} />
          )}
          {Math.abs(trend)}%
        </span>
      )}
    </div>
    <div className="space-y-1">
      <p className="text-sm font-medium text-slate-500">{title}</p>
      <p className="text-2xl font-bold text-slate-900">{value}</p>
      {subValue && <p className="text-xs text-slate-400">{subValue}</p>}
    </div>
  </div>
);

export default StatCard;
